// API configuration for web app with Neon backend integration.
//
// NEXT_PUBLIC_* vars are inlined into the client bundle at build time. If
// NEXT_PUBLIC_API_URL is missing during a production build, the localhost
// fallback gets baked into the bundle and every browser-side request hits
// http://localhost:4000 — the prod CSP correctly blocks this, leaving users
// with silently broken pages and no obvious server-side error to chase.
// Fail loud at build time in prod environments instead of silently degrading.
// Dev/test/CI environments keep the localhost fallback for convenience.
//
// The `isCI` exception below mirrors the same guard in `next.config.js` so
// both entry points enforce identical conditions — without it, CI builds
// would fail in `config/api.ts` but pass `next.config.js`, which was the
// non-determinism CodeRabbit flagged on PR #2275.
const NEXT_PUBLIC_API_URL = process.env.NEXT_PUBLIC_API_URL;
const NEXT_PUBLIC_WS_URL = process.env.NEXT_PUBLIC_WS_URL;
const isCI = process.env.CI === 'true' || process.env.GITHUB_ACTIONS === 'true';
if (
  process.env.NODE_ENV === 'production' &&
  process.env.NEXT_PHASE === 'phase-production-build' &&
  !isCI &&
  !NEXT_PUBLIC_API_URL
) {
  throw new Error(
    'NEXT_PUBLIC_API_URL is required for production builds. Set it in Vercel project settings (build environment) before deploying — otherwise the localhost:4000 fallback will be inlined into the client bundle and CSP will block it in the browser.',
  );
}
const API_BASE_URL = NEXT_PUBLIC_API_URL || 'http://localhost:4000';
const WS_BASE_URL = NEXT_PUBLIC_WS_URL || 'ws://localhost:4001';

// API endpoints configuration
export const API_ENDPOINTS = {
  rest: `${API_BASE_URL}`,
  websocket: `${WS_BASE_URL}/ws`,
  events: {
    // All event routes are mounted under /api/v1 by services/backend-api/src/routes/versions/v1/events.ts.
    // Earlier the nearby and byId entries were missing the /api/v1 prefix and silently 404'd.
    nearby: `${API_BASE_URL}/api/v1/events/nearby`,
    byId: (id: string) => `${API_BASE_URL}/api/v1/events/${id}`,
    search: `${API_BASE_URL}/api/v1/events/search`,
    searchSuggestions: `${API_BASE_URL}/api/v1/events/search/suggestions`,
    categories: `${API_BASE_URL}/api/v1/events/categories`,
  },
  analytics: {
    trending: `${API_BASE_URL}/api/v1/analytics/trending`,
    track: `${API_BASE_URL}/api/v1/analytics/track`,
    engagement: (eventId: string) => `${API_BASE_URL}/api/v1/analytics/engagement/${eventId}`,
  },
  auth: {
    register: `${API_BASE_URL}/api/v1/auth/register`,
    login: `${API_BASE_URL}/api/v1/auth/login`,
    logout: `${API_BASE_URL}/api/v1/auth/logout`,
    me: `${API_BASE_URL}/api/v1/auth/me`,
    forgotPassword: `${API_BASE_URL}/api/v1/auth/forgot-password`,
    resetPassword: `${API_BASE_URL}/api/v1/auth/reset-password`,
    refresh: `${API_BASE_URL}/api/v1/auth/refresh`,
    verifyEmail: `${API_BASE_URL}/api/v1/auth/verify-email`,
    resendVerification: `${API_BASE_URL}/api/v1/auth/resend-verification`,
    magicLinkRequest: `${API_BASE_URL}/api/v1/auth/magic-link/request`,
    magicLinkConsume: `${API_BASE_URL}/api/v1/auth/magic-link/consume`,
  },
};

export { API_BASE_URL, WS_BASE_URL };
